import { Control, FieldPath, FieldValues } from "react-hook-form";
import { FormControl, FormField, FormItem } from "../base/form";
import { TextInput } from "../inputs/text-input";
import { ComponentProps } from "react";

interface ControlledTextInputProps<TFieldValues extends FieldValues>
  extends Omit<ComponentProps<typeof TextInput>, "name" | "state" | "message"> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  className?: string;
  state?: "default" | "error";
  suppressErrorMessage?: boolean;
}

export function ControlledTextInput<TFieldValues extends FieldValues>({
  control,
  name,
  className,
  state,
  suppressErrorMessage,
  ...textInputProps
}: ControlledTextInputProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={className}>
          <FormControl>
            <TextInput
              {...field}
              {...textInputProps}
              state={state ?? (fieldState.error ? "error" : "default")}
              message={suppressErrorMessage ? undefined : fieldState.error?.message}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
